module.exports = __webpack_public_path__ + "static/media/video1.0396ec34.png";